import firebase from 'firebase';
import { serializer } from './shared/serializer';

const getDeviceById = async (deviceId: string) => {
  const device = await firebase
    .firestore()
    .collection('devices')
    .doc(deviceId)
    .get();

  return serializer.documentSnapshotToDocument(device);
};

export const devices = {
  getDeviceById
};
